module.exports = __webpack_public_path__ + "static/media/icon-amex-card.abe4297c.svg";